// Centralized Phaser asset preloading
export function preloadPhaserAssets(scene: Phaser.Scene) {
  // Player sprite
  scene.load.spritesheet("player", "/sprites/player.png", {
    frameWidth: 32,
    frameHeight: 32,
  });

  // Merchant sprites
  scene.load.spritesheet("enemies/merchants", "/sprites/enemies/merchants.png", {
    frameWidth: 32,
    frameHeight: 32,
  });

  // Enemy sprites - preload known enemy sprites (all are 2-frame spritesheets)
  scene.load.spritesheet("enemy_bot", "/sprites/enemies/bot.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("enemy_creepy", "/sprites/enemies/creepy.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("enemy_goboom", "/sprites/enemies/goo-boom.png", {
    frameWidth: 64,
    frameHeight: 64,
  });
  scene.load.spritesheet(
    "enemy_mutant_lord",
    "/sprites/enemies/mutant-lord.png",
    { frameWidth: 64, frameHeight: 64 },
  );
  scene.load.spritesheet("enemy_scavenger", "/sprites/enemies/scavenger.png", {
    frameWidth: 32,
    frameHeight: 32,
  });

  // Attack sprites
  scene.load.image("melee-attack", "/sprites/melee-attack.png");

  // Explosion animation - 3x3 grid, 64x64 px per frame
  scene.load.spritesheet("explosion", "/sprites/explosion.png", {
    frameWidth: 64,
    frameHeight: 64,
  });

  // Equipment and items
  scene.load.spritesheet("weapon", "/sprites/items/weapon.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("armor", "/sprites/items/armor.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("medic", "/sprites/items/medic.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("ammo", "/sprites/items/ammo.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("items", "/sprites/items/items.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("mining", "/sprites/items/mining.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("cyberjunk", "/sprites/items/cyberjunk.png", {
    frameWidth: 32,
    frameHeight: 32,
  });

  // Equip icons
  scene.load.image("equip-action", "/sprites/icons/equip-action.png");
  scene.load.image("equip-back", "/sprites/icons/equip-back.png");
  scene.load.image("equip-chest", "/sprites/icons/equip-chest.png");
  scene.load.image("equip-feet", "/sprites/icons/equip-feet.png");
  scene.load.image("equip-hands", "/sprites/icons/equip-hands.png");
  scene.load.image("equip-head", "/sprites/icons/equip-head.png");
  scene.load.image("equip-legs", "/sprites/icons/equip-legs.png");
  scene.load.image("equip-weapon", "/sprites/icons/equip-weapon.png");
  scene.load.image("close-icon", "/sprites/icons/close-icon.png");
  scene.load.image("armor-icon", "/sprites/icons/armor-icon.png");

  // Crafting icons
  scene.load.image("crafting-weapon-icon", "/sprites/icons/crafting-weapon-icon.png");
  scene.load.image("crafting-ammo-icon", "/sprites/icons/crafting-ammo-icon.png");
  scene.load.image("crafting-support-icon", "/sprites/icons/crafting-support-icon.png");

  // Map tilesets
  scene.load.image("container", "/sprites/map/chest.png");
  scene.load.image("airdrop-box", "/sprites/map/airdrop-box.png");
  scene.load.image("airplane-shadow", "/sprites/airplane-shadow.png");
  scene.load.image("airstrike-crosshair", "/sprites/airstrike-crosshair.png");
  scene.load.image("parachute", "/sprites/map/parachute.png");
  scene.load.image("arrow-blue", "/sprites/arrow-blue.png");
  scene.load.spritesheet(
    "teleport-active",
    "/sprites/map/teleport-active.png",
    { frameWidth: 96, frameHeight: 96 },
  );

  // Product skins (2-frame spritesheets)
  scene.load.spritesheet("skin1", "/sprites/products/skin1.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("skin2", "/sprites/products/skin2.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("skin3", "/sprites/products/skin3.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("skin4", "/sprites/products/skin4.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("skin5", "/sprites/products/skin5.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("skin6", "/sprites/products/skin6.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("skin7", "/sprites/products/skin7.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  // Season-exclusive skins live under sprites/season/skins/ (not products/), since
  // they're granted by a season reward rather than sold as a regular IAP product —
  // see server/data/season-skins.json for the editor-facing catalog of these.
  scene.load.spritesheet("skin8", "/sprites/season/skins/skin8.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("skin9", "/sprites/season/skins/skin9.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("skin10", "/sprites/season/skins/skin10.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.spritesheet("skin11", "/sprites/season/skins/skin11.png", {
    frameWidth: 32,
    frameHeight: 32,
  });

  // Season sprays — placed on the ground as stickers (see StickerManager)
  scene.load.image("spray-1", "/sprites/season/sprays/spray-1.png");
  scene.load.image("spray-2", "/sprites/season/sprays/spray-2.png");
  scene.load.image("spray-3", "/sprites/season/sprays/spray-3.png");
  scene.load.image("spray-4", "/sprites/season/sprays/spray-4.png");
  scene.load.image("spray-5", "/sprites/season/sprays/spray-5.png");

  // Equippable hat skins — worn on the player sprite (see Player.updateHatSprite)
  for (let i = 1; i <= 16; i++) {
    scene.load.image(`hat-${i}`, `/sprites/season/hats/hat-${i}.png`);
  }

  // Season screen background
  scene.load.image("season-bg", "/sprites/season/season-bg.jpg");
  scene.load.image("season-ticket-premium", "/sprites/season/season-ticket-premium.png");
  scene.load.image("season-ticket-free", "/sprites/season/season-ticket-free.png");
  scene.load.image("season-checkered-free", "/sprites/season/checkered-free.png");
  scene.load.image("season-checkered-premium", "/sprites/season/checkered-premium.png");

  // Emoticons icon (button icon)
  scene.load.image("emoticons-icon", "/sprites/icons/emoticons.png");

  // Emoticon faces - single spritesheet of static frames (8 cols × 8 rows, 32×32
  // per frame). Frame index doubles as the emoticon's key ("emoticon-<frame>").
  scene.load.spritesheet("emoticons", "/sprites/emoticons/emoticons.png", {
    frameWidth: 32,
    frameHeight: 32,
  });

  // Speech-bubble pop-in/out animation shown behind the selected emoticon face
  // (5 cols × 4 rows, 32×32 per frame).
  scene.load.spritesheet("bubble-animation", "/sprites/emoticons/bubble-animation.png", {
    frameWidth: 32,
    frameHeight: 32,
  });

  // End screen backgrounds
  scene.load.image("death-bg", "/sprites/death-bg.png");
  scene.load.image("success-bg", "/sprites/success-bg.png");

  // UI icons
  scene.load.image("no-wifi-icon", "/icons/no-wifi-icon.svg");
  scene.load.image("logo-portal", "/icons/logo-portal-only.png");
  scene.load.image("lock-icon", "/sprites/icons/lock-icon.png");
  scene.load.image("title-icon", "/sprites/season/title-icon.png");

  scene.load.spritesheet("item-type-icons", "/sprites/icons/item-type-icons.png", {
    frameWidth: 20,
    frameHeight: 20,
  });
  scene.load.spritesheet("weekly-rewards", "/sprites/base/weekly-rewards.png", {
    frameWidth: 64,
    frameHeight: 64,
  });
  scene.load.spritesheet("blood-splatter", "/sprites/base/blood-splatter.png", {
    frameWidth: 32,
    frameHeight: 32,
  });
  scene.load.image("cross", "/sprites/base/cross.png");
  scene.load.image("checkmark", "/sprites/base/checkmark.png");
}
// Centralized sprite loader for all game graphics
// Usage: import { SpriteLoader } from './sprite-loader';
// Call SpriteLoader.loadAll() in index.ts

export class SpriteLoader {
  private static images: Map<string, HTMLImageElement> = new Map();

  static spriteList: string[] = [
    // Equip icons
    "sprites/icons/equip-action.png",
    "sprites/icons/equip-back.png",
    "sprites/icons/equip-chest.png",
    "sprites/icons/equip-feet.png",
    "sprites/icons/equip-hands.png",
    "sprites/icons/equip-head.png",
    "sprites/icons/equip-legs.png",
    "sprites/icons/equip-weapon.png",
    // Other icons
    "sprites/icons/backpack-icon.png",
    "sprites/icons/player-icon.png",
    // Item sprites
    "sprites/ammo.png",
    "sprites/armor.png",
    "sprites/medic.png",
    "sprites/player.png",
    "sprites/weapon.png",
    // Map sprites
    "sprites/map/PA_town_objects.png",
    "sprites/map/robot-shop.png",
    "sprites/airplane-shadow.png",
    "sprites/map/airdrop-box.png",
    "sprites/map/parachute.png",
  ];

  static loadAll(): Promise<void> {
    const promises = this.spriteList.map((path) => {
      return new Promise<void>((resolve, reject) => {
        const img = new window.Image();
        img.src = path;
        img.onload = () => {
          this.images.set(path, img);
          resolve();
        };
        img.onerror = reject;
      });
    });
    return Promise.all(promises).then(() => {});
  }

  static getImage(path: string): HTMLImageElement | undefined {
    return this.images.get(path);
  }

  // Map item type to number of columns in its spritesheet
  static createSprite(
    scene: Phaser.Scene,
    spriteSheet: string,
    frameX: number,
    frameY: number,
    x: number,
    y: number,
    fixedUI: boolean,
  ): Phaser.GameObjects.Sprite {
    const spriteSize = 32;
    const typeColumns: Record<string, number> = {
      weapon: 10,
      armor: 10,
      medic: 2,
      ammo: 10,
      items: 16,
      cyberjunk: 10,
      mining: 10,
      radioactive: 10,
      "enemies/merchants": 2,
    };
    const key = spriteSheet;
    const columns = typeColumns[key] || 4;
    // Use item.spriteX and item.spriteY for frame index
    const frame = frameY * columns + frameX;
    const sprite = scene.add.sprite(x, y, key, frame);
    sprite.setOrigin(0.5);
    sprite.setScrollFactor(fixedUI ? 0 : 1); // Anchor to map or UI
    sprite.displayWidth = spriteSize;
    sprite.displayHeight = spriteSize;
    return sprite;
  }
}
